import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09f1e5e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "changelog" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "value-from" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "value-to" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Link = _resolveComponent("Link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, _toDisplayString(_ctx.date), 1),
    _createElementVNode("p", null, _toDisplayString(_ctx.fieldName), 1),
    (_ctx.changelog.user)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.changelog.user.firstname) + " " + _toDisplayString(_ctx.changelog.user.lastname) + " (" + _toDisplayString(_ctx.changelog.caused_by) + ") ", 1))
      : (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.changelog.caused_by), 1)),
    _createElementVNode("p", null, [
      (_ctx.changelog.linked_to_id && _ctx.changelog.linked_to_type === 'order')
        ? (_openBlock(), _createBlock(_component_Link, {
            key: 0,
            href: _ctx.route('orders.show', { order: _ctx.changelog.linked_to_id })
          }, {
            default: _withCtx(() => [
              _createTextVNode("Ordre " + _toDisplayString(_ctx.changelog.linked_to_id), 1)
            ]),
            _: 1
          }, 8, ["href"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("p", _hoisted_4, [
      ((_ctx.changelog.value_from?.length ?? 0) > 150)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("span", {
              class: "showAllButton",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAllContent = !_ctx.showAllContent))
            }, _toDisplayString(_ctx.showAllContent ? "Vis mindre" : "Vis alt"), 1),
            _hoisted_5
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("span", { innerHTML: _ctx.valueFrom }, null, 8, _hoisted_6),
      _createElementVNode("span", null, _toDisplayString(_ctx.fromHasMoreContent ? "..." : ""), 1)
    ]),
    _createElementVNode("p", _hoisted_7, [
      ((_ctx.changelog.value_to?.length ?? 0) > 150)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("span", {
              class: "showAllButton",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAllContent = !_ctx.showAllContent))
            }, _toDisplayString(_ctx.showAllContent ? "Vis mindre" : "Vis alt"), 1),
            _hoisted_8
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("span", { innerHTML: _ctx.valueTo }, null, 8, _hoisted_9),
      _createElementVNode("span", null, _toDisplayString(_ctx.toHasMoreContent ? "..." : ""), 1)
    ])
  ]))
}